import axios from 'axios';
import { useReducer } from 'react';

const initialState = {
  document: null,
  isPending: false,
  error: null,
  success: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'IS_PENDING':
      return { ...state, error: null, isPending: true };
    case 'IS_SUCCESS':
      return {
        document: action.payload,
        isPending: false,
        error: null,
        success: true,
      };

    case 'IS_ERROR':
      return {
        document: null,
        isPending: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export const useAdminRequest = () => {
  const [response, dispatch] = useReducer(reducer, initialState);

  const post = async (url, datas) => {
    dispatch({ type: 'IS_PENDING' });
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      const { data } = await axios.post(url, datas, config);
      dispatch({ type: 'IS_SUCCESS', payload: data });
    } catch (error) {
      dispatch({ type: 'IS_ERROR', payload: error.message });
    }
  };

  const put = async (url, datas) => {
    dispatch({ type: 'IS_PENDING' });
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      const { data } = await axios.put(url, datas, config);
      dispatch({ type: 'IS_SUCCESS', payload: data });
    } catch (error) {
      console.log(error);
      dispatch({ type: 'IS_ERROR', payload: error.message });
    }
  };

  const deleteBlog = async (url) => {
    dispatch({ type: 'IS_PENDING' });
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const config = {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      };

      await axios.delete(url, config);
      dispatch({ type: 'IS_SUCCESS', payload: null });
    } catch (error) {
      console.log(error);
      dispatch({ type: 'IS_ERROR', payload: error.message });
    }
  };
  return { post, put, deleteBlog, response };
};
